// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/taxi-authorization-and-communication.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/taxi-authorization-and-communication/taxi-authorization-and-communication.js';

mount([g0]);
